import React from 'react';
import { isSmartPhone } from '../../utilities/helper';
import TransactionEarningItemMWeb from './index_mWeb';
import TransactionEarningItemWeb from './index_web';

interface Props {
  item: any;
}

const TransactionEarningItem = ({ item }: Props) => {
  const {
    referlBonus = false,
    signupBonus = false,
    affiliateId = null,
    referredUserId = null
  } = item;

  const creditType = referlBonus
    ? 'Referral Bonus'
    : signupBonus
    ? 'Registration Bonus'
    : affiliateId
    ? 'Affiliate Earning'
    : referredUserId
    ? 'Referral Earning'
    : '';

  return (
    <>
      {isSmartPhone ? (
        <TransactionEarningItemMWeb item={item} creditType={creditType} />
      ) : (
        <TransactionEarningItemWeb item={item} creditType={creditType} />
      )}
    </>
  );
};
export default React.memo(TransactionEarningItem);
